import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-gebruiker-ingelogd',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGebruikerIngelogd {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M26.97 13.05V9.08c0-5-4.04-9.08-9-9.08s-9 4.07-9 9.08V10h3v-.92c0-3.35 2.69-6.08 6-6.08s6 2.73 6 6.08V13H9.52c-2.51 0-4.55 2.04-4.55 4.55V31.5c0 2.49 2.01 4.5 4.5 4.5h17c2.49 0 4.5-2.01 4.5-4.5v-14c0-2.31-1.76-4.2-4-4.45m-8.93 4.99c1.66.01 2.99 1.36 2.98 3.02s-1.36 2.99-3.02 2.98c-1.65 0-2.99-1.36-2.98-3.01 0-1.65 1.36-2.99 3.01-2.98ZM22.97 31h-10v-2.25c0-1.54 1.31-2.75 2.89-2.75h4.29c1.58 0 2.82 1.21 2.82 2.75z"/>
</svg>

    );
  }
}
